// TOP LEVEL IMPORTS
import gql from 'graphql-tag';
import lineItemFragment from 'ApolloClient/Fragments/lineItemFragment';

export default gql`
  fragment invoiceFragment on Invoice {
    _id
    clientId
    status
    createdAt
    number
    paidAt
    sentAt
    amount
    finalPaymentAmount
    salesTax
    totalWithTax
    taxAmount
    discountAmount
    subtotalAfterDiscount
    currency
    lineItems {
      ...lineItemFragment
    }
    due
    organization {
      _id
      title
      email
      image
      city
      state
      street1
      street2
      zip
    }
    client {
      _id
      firstName
      lastName
      email
    }
  }
  ${lineItemFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/invoiceFragment.js